const desanitizeString = (value) => value ? value.replaceAll('&#39;', "'") : '';

export default desanitizeString;
